import React, { useState, useEffect } from 'react'
import {
  Container,
  Box,
  TextField,
  Button,
  CircularProgress,
  Snackbar,
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import firebase from 'firebase/app'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'
import './styles.scss'
//HELPERS
import { isEmpty, isEmailValid, getDateTime } from '../../utils/helpers'

//API
import { createContact } from '../../services/FirebaseServices/agencyServices'

const ContactView = ({ agency, setSnackBarOpen, handleTabChange }) => {
  //COMPONENT STATE
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState('')
  const [reCaptchaIsValid, setReCaptchaIsValid] = useState(true)
  const [isCheck, setIsCheck] = useState(false)
  const [loadingContact, setLoadingContact] = useState(false)

  //VALIDATION
  const [nameValid, setNameValid] = useState({ isValid: true, message: '' })
  const [emailValid, setEmailValid] = useState({ isValid: true, message: '' })
  const [subjectValid, setSubjectValid] = useState({
    isValid: true,
    message: '',
  })
  const [messageValid, setMessageValid] = useState({
    isValid: true,
    message: '',
  })
  const [phoneValid, setPhoneValid] = useState({
    isValid: true,
    message: '',
  })

  useEffect(() => {
    setUpRecaptcha()
  }, [])

  const setUpRecaptcha = () => {
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      'recaptcha-container',
      {
        size: 'normal',
        callback: (response) => {
          // reCAPTCHA solved,
          // ...
          setIsCheck(true)
        },
        'expired-callback': () => {
          // Response expired. Ask user to solve reCAPTCHA again.
          // ...
          setIsCheck(false)
        },
      },
    )

    window.recaptchaVerifier.render().then((widgetId) => {
      window.recaptchaWidgetId = widgetId
    })
  }

  const validateName = (nameValue) => {
    if (isEmpty(nameValue)) {
      setNameValid({ isValid: false, message: 'Por favor complete este campo' })
      return false
    }

    setNameValid({ isValid: true, message: '' })
    return true
  }

  const validateEmail = (emailValue) => {
    if (isEmpty(emailValue)) {
      setEmailValid({
        isValid: false,
        message: 'Por favor, complete este campo',
      })
      return false
    }

    if (!isEmailValid(emailValue)) {
      setEmailValid({
        isValid: false,
        message: 'El correo ingresado no es valido',
      })
      return false
    }

    setEmailValid({
      isValid: true,
      message: '',
    })
    return true
  }

  const validateSubject = (subjectValue) => {
    if (isEmpty(subjectValue)) {
      setSubjectValid({
        isValid: false,
        message: 'Por favor, complete este campo',
      })
      return false
    }
    setSubjectValid({
      isValid: true,
      message: '',
    })
    return true
  }

  const validateMessage = (messageValue) => {
    if (isEmpty(messageValue)) {
      setMessageValid({
        isValid: false,
        message: 'Por favor, complete este campo',
      })
      return false
    }
    setMessageValid({
      isValid: true,
      message: '',
    })
    return true
  }

  const handleReCaptchaValidation = () => {
    if (isCheck) {
      setReCaptchaIsValid(true)
      return true
    } else {
      setReCaptchaIsValid(false)
      return false
    }
  }

  const validatePhone = (phoneValue) => {
    if (isEmpty(phoneValue)) {
      setPhoneValid({
        isValid: false,
        message: 'Por favor, complete este campo',
      })
      return false
    }

    if (phoneValue.length < 11) {
      setPhoneValid({
        isValid: false,
        message: 'El numero ingresado no es valido',
      })
      return false
    }

    setPhoneValid({
      isValid: true,
      message: '',
    })
    return true
  }

  const handleSubmit = async () => {
    setLoadingContact(true)
    const boolName = validateName(name)
    const boolEmail = validateEmail(email)
    const boolSubject = validateSubject(subject)
    const boolMessage = validateMessage(message)
    const boolRecaptcha = handleReCaptchaValidation()
    const boolPhone = validatePhone(phone)

    if (
      boolName &&
      boolEmail &&
      boolSubject &&
      boolMessage &&
      boolRecaptcha &&
      boolPhone
    ) {
      const contactData = {
        name,
        email,
        subject,
        message,
        isRead: false,
        phone,
        createdAt: getDateTime(),
      }

      try {
        await createContact(agency.key, contactData)
        setSnackBarOpen({
          isOpen: true,
          message: 'Su mensaje se ha enviado correctamente.',
          type: 'success',
        })
        setLoadingContact(false)
        handleTabChange(null, 0)
      } catch (err) {
        setSnackBarOpen({
          isOpen: true,
          message:
            'Hubo un error al enviar su mensaje. Por favor, intente de nuevo mas tarde.',
          type: 'warning',
        })
      }
    } else {
      setLoadingContact(false)
    }
  }

  return (
    <Container>
      <Box component="h2" textAlign="center">
        Comunicate con nosotros!
      </Box>
      <Box component="p" textAlign="center">
        No dudes en escribirnos si tienes alguna duda o sugerencia.
      </Box>
      <Box display="flex" justifyContent="center">
        <Box className="containerForm">
          <form
            noValidate
            onSubmit={(event) => {
              event.preventDefault()
              handleSubmit()
            }}
            className="form"
          >
            <Box className="mediaField">
              <TextField
                label="Nombre"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{ marginBottom: '1rem', backgroundColor: 'white' }}
                helperText={!nameValid.isValid && nameValid.message}
                error={!nameValid.isValid}
                variant="outlined"
                onBlur={(e) => validateName(e.target.value)}
                fullWidth
              />
            </Box>
            <Box className="mediaField">
              <TextField
                label="Email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ marginBottom: '1rem', backgroundColor: 'white' }}
                helperText={!emailValid.isValid && emailValid.message}
                error={!emailValid.isValid}
                variant="outlined"
                onBlur={(e) => validateEmail(e.target.value)}
                fullWidth
              />
            </Box>

            <Box marginBottom={3} className="mediaField">
              <PhoneInput
                isValid={phoneValid.isValid}
                country="cl"
                preferredCountries={['cl', 'br', 'us']}
                value={phone}
                onChange={(value, country, e, formattedValue) =>
                  setPhone(value)
                }
                masks={{ cl: '(..) ... ....' }}
                specialLabel="Teléfono *"
                autoFormat
                onBlur={(e) => {
                  validatePhone(phone)
                }}
              />
              {!phoneValid.isValid && (
                <p className="phone-validation">{phoneValid.message}</p>
              )}
            </Box>
            <Box className="mediaField">
              <TextField
                label="Asunto"
                required
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                style={{ marginBottom: '1rem', backgroundColor: 'white' }}
                helperText={!subjectValid.isValid && subjectValid.message}
                error={!subjectValid.isValid}
                variant="outlined"
                onBlur={(e) => validateSubject(e.target.value)}
                fullWidth
              />
            </Box>

            <Box className="mediaField">
              <TextField
                label="Mensaje"
                required
                multiline
                rows={5}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                style={{ marginBottom: '1rem', backgroundColor: 'white' }}
                helperText={!messageValid.isValid && messageValid.message}
                error={!messageValid.isValid}
                variant="outlined"
                onBlur={(e) => validateMessage(e.target.value)}
                fullWidth
              />
            </Box>

            <div
              id="recaptcha-container"
              style={{ display: 'flex', justifyContent: 'center' }}
            />
            {!reCaptchaIsValid && (
              <span
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  color: 'red',
                  fontSize: '12px',
                }}
              >
                Debe verificar su identidad
              </span>
            )}
            <Box textAlign="end" className="btn-contact">
              <Button
                type="submit"
                value="Submit"
                color="primary"
                variant="contained"
              >
                {loadingContact ? (
                  <CircularProgress size={20} style={{ color: 'white' }} />
                ) : (
                  'Enviar'
                )}
              </Button>
            </Box>
          </form>
        </Box>
      </Box>
      {/*  <Snackbar
        open={snackBarOpen.isOpen}
        autoHideDuration={6000}
        onClose={() =>
          setSnackBarOpen({ isOpen: false, message: '', type: 'warning' })
        }
      >
        <Alert
         
          severity={snackBarOpen.type}
        >
          {snackBarOpen.message}
        </Alert>
      </Snackbar> */}
    </Container>
  )
}

export default ContactView
